import { Component, OnDestroy, OnInit } from '@angular/core';
import { ProfileService } from 'src/app/profile-home/service/profile.service';
import { ActivatedRoute, Router } from '@angular/router';
import { take, finalize } from 'rxjs/operators';
import { Profile } from 'src/app/core/models/profile';
import { LayoutService } from 'src/app/core/services/layout/layout.service';
import { SearchOrder } from '../components/search-order/model/search-order.model';
import { BrokerProfileService } from './broker-profile.service';
import { ProductCard } from '../models/product-card.model';
import { Subscription } from 'rxjs';
import { SearchSummary } from '../models/search-summary.model';
import { SearchPagination } from '../models/search-pagination.model';
import { EnvironmentService } from 'src/app/core/enviroment/environment.service';
import { DealTypeEnum } from '../components/search-filter/model/deal-type.enum';
import { ProductTypeEnum } from '../models/product-type.enum';
import { LoginService } from 'lps-navigation';
import { Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-broker-profile',
  templateUrl: './broker-profile.component.html',
  styleUrls: ['./broker-profile.component.scss']
})
export class BrokerProfileComponent implements OnInit, OnDestroy {

  loading: boolean;
  loadingProducts: boolean;
  nickname: string;
  profile: Profile;
  year = new Date().getFullYear();
  order: SearchOrder;
  searchContent: Array<ProductCard>;
  totalElements = 0;
  pageIndex = 1;
  pageSize = 24;
  searchSummary: SearchSummary = {
    length: 0,
    formatted: '',
    location: '',
    summary: ''
  };
  pagination: SearchPagination;
  uriProduct = this.environmentService.getEnvVar('portal_url');
  firstLoading = true;

  paginationSubsc = new Subscription();
  loadingSubsc = new Subscription();
  productsSubsc = new Subscription();
  updateSubsc = new Subscription();

  constructor(
    public service: ProfileService,
    public route: ActivatedRoute,
    public router: Router,
    public layoutService: LayoutService,
    public brokerProfileService: BrokerProfileService,
    private environmentService: EnvironmentService,
    private loginService: LoginService,
    private meta: Meta
  ) { }

  ngOnInit() {
    this.meta.addTag({ name: 'robots', content: 'noindex, nofollow' });
    this.nickname = this.route.snapshot.params.name;
    this.layoutService.setShowFooter(false);
    this.listenLoading();
    this.listenProducts();
    this.listenPagination();
    this.brokerProfileService.filter.setValues({
      dealType: DealTypeEnum.Sale,
      productTypes: [ProductTypeEnum.RealEstateParent, ProductTypeEnum.RealState]
    });
    this.getBroker();
    this.getBrokerProducts();
    this.listenUpdateProfile();
  }

  ngOnDestroy() {
    this.meta.removeTag('name="robots"');
    this.layoutService.setShowFooter(true);
    this.paginationSubsc.unsubscribe();
    this.loadingSubsc.unsubscribe();
    this.updateSubsc.unsubscribe();
  }

  listenLoading(): void {
    this.loadingSubsc = this.brokerProfileService.loading$
      .subscribe(load => this.loadingProducts = load);
  }

  getBroker(): void {
    sessionStorage.setItem('broker-nickname', this.nickname);
    this.loading = true;
    this.service.findByName(this.nickname)
    .pipe(
      take(1),
      finalize(() => this.loading = false)
    ).subscribe((profile: Profile) => {
      if (profile.is_valid_creci) {
        if (this.validatesUserAccess(profile)) {
          this.profile = profile;
          this.service.sendPerfil(profile);
        }
      } else {
        this.router.navigate(['/']);
      }
    }, () => this.router.navigate(['/']));
  }

  validatesUserAccess(profile: Profile): boolean {
    if (this.loginService.getAuthInformation().isUserLoggedIn() && !profile.is_owner) {
      const destination = `${this.environmentService.getBaseCrmUrl()}/home`;
      window.location.href = destination;
    }
    return true;
  }

  getBrokerProducts(page?: number): void {
    this.brokerProfileService.getBrokerProducts(this.nickname, page)
    .pipe(
      take(1),
      finalize(() => this.loadingProducts = false)
    ).subscribe(res => {
      this.searchContent = res;
      this.setSummary(res);
      this.firstLoading = false;
    }, () => this.searchContent = []);
  }

  listenProducts(): void {
    this.productsSubsc = this.brokerProfileService.products$
    .subscribe(prod => {
      this.setSummary(prod);
      this.searchContent = prod;
    });
  }

  changeOrder(order: SearchOrder) {
    this.order = order;
    this.brokerProfileService.filter.setOrder(order);
    this.brokerProfileService.filter.setPage(1);
    this.getBrokerProducts();
  }

  navigate(page: number): void {
    this.brokerProfileService.filter.setPage(page);
    this.getBrokerProducts(page - 1);
  }

  listenPagination(): void {
    this.paginationSubsc = this.brokerProfileService.pagination$
      .subscribe((pagination) => {
        if (pagination) {
          this.searchSummary.length = pagination.totalElements;
          this.totalElements = pagination.totalElements;
          this.pageIndex = pagination.number;
          this.pageSize = pagination.size;
        }
      });
  }

  setSummary(products: Array<ProductCard>): void {
    this.searchSummary.length = !products.length ? 0 : this.totalElements;
    if (this.searchSummary.length) {
      this.searchSummary = {
        ...this.searchSummary,
        formatted: `Tenho ${this.searchSummary.length} imóveis que possam te interessar.`
      };
    }
  }

  listenUpdateProfile(): void {
    this.updateSubsc = this.service.getUpdateProfile()
    .subscribe(res => {
      if (res) {
        this.getBroker();
      }
    });
  }

}
